import Cookies from 'js-cookie';
import toast from "react-hot-toast";
import { axiosInstance } from '../lib/axios';

const getVendorapi = async () => {
    try {
        const res = await axiosInstance.get(`/vendor`)
        return res.data.data
    } catch (err) {
        console.log(err.response?.data?.message);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

const postVendor = async (form, id) => {
    try {
        const {
            vendorName, images, vendorType, contactPerson, emailAddress, phoneNumber, website, address, additionalNotes, vendorStatus
        } = form;

        const formData = new FormData();
        // Required Field
        formData.append("vendorName", vendorName);
        formData.append("vendorType", vendorType);
        formData.append("contactPerson", contactPerson);
        formData.append("emailAddress", emailAddress);
        formData.append("phoneNumber", phoneNumber);
        formData.append("website", website);
        formData.append("address", JSON.stringify(address));
        formData.append("additionalNotes", additionalNotes);
        formData.append("vendorStatus", vendorStatus);

        if (images) {
            if (typeof images === "string") {
                formData.append("images", images);
            }
            else {
                formData.append("pictures", images);
            }
        }

        if (id) {
            formData.append("id", id);
        }

        const accessToken = Cookies.get("accessToken");

        const res = await axiosInstance.post(
            `/vendor`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        console.log("vendor", res)
        toast.success("Successfully Registered!");
        return res.data?.data;

    } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

const getVendorByIdFunction = async (id) => {
    try {

        const params = new URLSearchParams();
        params.append('id', id);

        const res = await axiosInstance.get(`/vendor/id?${params.toString()}`)
        toast.success("Successfully fetched!");
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

const getAllVendorFunction = async (pageNumber, pageSize, search, field) => {
    try {

        const params = new URLSearchParams();
        params.append('field', field);
        params.append('search', search);
        params.append('pageSize', pageSize);
        params.append('pageNumber', pageNumber);

        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.get(`/vendor?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        // toast.success("Successfully fetched!");
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

const deleteVendor = async (id) => {
    try {

        if (!id) {
            toast.error("id is not present");
            return
        }
        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.delete(`/vendor/${id}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        toast.success("Successfully deleted!");
        // return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

const analyticsApi = async () => {
    try {
        const res = await axiosInstance.get(`/vendor/analytics`)
        return res.data
    } catch (err) {
        console.log(err.response?.data?.message);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

const dowloadvendorlist = async (pageNumber, pageSize, search, field) => {
    try {

        const params = new URLSearchParams();
        params.append('field', field);
        params.append('search', search);
        params.append('pageSize', pageSize);
        params.append('pageNumber', pageNumber);

        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.get(`/vendor/dowload?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
            responseType: "arraybuffer",
        })

        const blob = new Blob([res.data], { type: "application/pdf" });


        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        const now = new Date();
        const timeString = `${now.getHours()}_${now.getMinutes()}_${now.getSeconds()}`;
        link.download = `vendor-details_${timeString}.pdf`;


        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Clean up
        window.URL.revokeObjectURL(link.href);

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

export {
    postVendor,
    getVendorapi,
    getVendorByIdFunction,
    getAllVendorFunction,
    deleteVendor,
    analyticsApi,
    dowloadvendorlist
}
